import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function planTermList(query?: { [key: string]: any }) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`plan/term/list${queryString}`);
}

export async function planTermShow(item_id: string) {
	return await clientAxios.get(`plan/term/${item_id}/show`);
}

export async function planTermCreate(payload: any) {
	return await clientAxios.post(`plan/term/create`, payload);
}

export async function planTermPatch(item_id: string, payload: Partial<any>) {
	return await clientAxios.patch(`plan/term/${item_id}/patch`, { payload });
}

export async function planTermDelete(item_id: string) {
	return await clientAxios.del(`plan/term/${item_id}/delete`);
}
